import { render, staticRenderFns } from "./RoleSection.vue?vue&type=template&id=58bcbd37"
import script from "./RoleSection.vue?vue&type=script&lang=js"
export * from "./RoleSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports